import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const defaultMimeType = 'application/json';

const reportingApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
reportingApiInstance.interceptors.request.use(requestInterceptor);

export default reportingApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/reportingApi.js